<template>
  <div class="col-12 nopads container">
    <span class="span-title">{{ $t('observations.select_equipment') }}</span>
    <multiselect
      v-model="selectedItem"
      :placeholder="$t('observations.select_equipment')"
      :deselect-label="$t('common.remove_selection')"
      :select-label="$t('common.select')"
      :close-on-select="true"
      :multiple="false"
      label="name"
      track-by="id"
      :searchable="true"
      :internal-search="true"
      :selected-label="$t('common.selected')"
      :options="equipments"
    >
      <template
        #singleLabel="props"
      >
          <div class="row align-items-center nopads">
              <!-- Image column with fixed width -->
              <div class="col-auto nopads">
                  <img
                      v-if="props.option.type !== EXTERNAL_TRAFFIC_SIGNS"
                      class="option__image"
                      :src="getEquipmentIcon(props.option.type, props.option.code)"
                      height="25"
                      alt=""
                  >
                  <img
                      v-else
                      class="option__image"
                      :src="getRoadSignImage(props.option.code)"
                      height="25"
                      alt=""
                  >
              </div>

              <!-- Flexible column taking remaining space -->
              <div class="col nopads">
                <span class="option__title">
                  {{ props.option.distance ? props.option.distance + ' m' : '?' }} -
                  {{ props.option.name }} ({{ props.option.id }})
                </span>
              </div>
          </div>
      </template>

      <template
        #option="props"
      >
          <div class="row align-items-center nopads">
              <!-- Image column with fixed width -->
              <div class="col-auto nopads">
                  <img
                      v-if="props.option.type !== EXTERNAL_TRAFFIC_SIGNS"
                      class="option__image"
                      :src="getEquipmentIcon(props.option.type, props.option.code)"
                      height="25"
                      alt=""
                  >
                  <img
                      v-else
                      class="option__image"
                      :src="getRoadSignImage(props.option.code)"
                      height="25"
                      alt=""
                  >
              </div>

              <!-- Flexible column taking remaining space -->
              <div class="col nopads">
                <span class="option__title">
                  {{ props.option.distance ? props.option.distance + ' m' : '?' }} -
                  {{ props.option.name }} ({{ props.option.id }})
                </span>
              </div>
          </div>

      </template>
      <template #noResult>
        <span>{{ $t('common.not_found') }}</span>
      </template>
      <template #noOptions>
        <span>{{ $t('common.no_results') }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";

const imageModules = import.meta.glob('@/assets/roadsign/**/*.{svg,png,jpg}', {eager: true});
export default {
    name: 'ExternalEquipmentSelector',
    mixins: [roadSignHelper, conversionModelHelper],
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        equipments: {
            type: Array,
            default: null
        },
        selected: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            selectedItem: null
        }
    },
    watch: {
        selectedItem(val) {
            this.$emit('update:modelValue', val)
        }
    },
    mounted() {
        if (this.selected) {
            let item = this.equipments.find(item => item.id === this.selected)
            this.selectedItem = item ? item : null
        }
    },
    methods: {
        getRoadSignImage(code) {
            try {
                const iconName = this.getSignIcon(code);
                const imagePath = `/src/assets/roadsign/${iconName}`;
                const imageModule = imageModules[imagePath];

                if (imageModule) {
                    return imageModule.default || imageModule;
                } else {
                    return ""; // Fallback for missing images
                }
            } catch (error) {
                console.warn(`Road sign image not found: ${code}`, error);
                return "";
            }
        }
    }
}
</script>
